import { Row, Col } from 'reactstrap';
import CheckBox from 'src/componentes/checkbox';
import PanelCollapse from 'src/componentes/panel-collapse';
import CopiaControladaDocumentoSection from '../Components/CopiaControladaDocumentoSection';
import {
  COPIA_CONTROLADA_FIELDS,
  TIPO_COPIA_DOCUMENTO,
} from '../Components/copiaControladaDocumentoConstants';
import DistribuicaoCopiasControladas from '../Components/DistribuicaoCopiasControladas';
import { useState, useEffect, useRef } from 'react';

function ConfiguracoesTab({
  intl,
  model,
  isDisabled,
  onChangeValue,
  hasErrorField,
  hasUnsavedChanges,
  isActive,
}) {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (isActive) {
      setRefreshTrigger((prev) => prev + 1);
    }
  }, [isActive]);

  const tipoCopiaDocumento =
    model?.[COPIA_CONTROLADA_FIELDS.TIPO_COPIA_DOCUMENTO_ID] ??
    model?.tipoCopiaDocumento ??
    TIPO_COPIA_DOCUMENTO.NAO_SE_APLICA;
  const showDownloads =
    tipoCopiaDocumento === TIPO_COPIA_DOCUMENTO.NAO_SE_APLICA;
  const ehCopiaControlada =
    tipoCopiaDocumento === TIPO_COPIA_DOCUMENTO.COPIA_CONTROLADA;

  return (
    <div style={{ paddingBottom: 24 }}>
      <PanelCollapse
        open={true}
        header={intl.formatMessage({ id: 'labelCopiaDoDocumento' })}
      >
        <CopiaControladaDocumentoSection
          intl={intl}
          documentoId={model?.id}
          isDisabled={isDisabled}
          getValue={(field) => model?.[field]}
          onChangeValue={onChangeValue}
          hasErrorField={hasErrorField}
          hasUnsavedChanges={hasUnsavedChanges}
        />
      </PanelCollapse>
      {showDownloads && (
        <PanelCollapse
          open={true}
          header={intl.formatMessage({ id: 'downloads' })}
        >
          <Row>
            <Col md={12}>
              <span>
                {intl.formatMessage({
                  id: 'tipoPermissaoDownload',
                })}
              </span>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <CheckBox
                className="mt-2"
                disabled={isDisabled}
                model={{
                  label: intl.formatMessage({
                    id: 'bloquearDownload',
                  }),
                  value: model?.bloquearDownload,
                  requestChange: (value) =>
                    onChangeValue('bloquearDownload', value),
                }}
              />
            </Col>
            <Col md={12}>
              <CheckBox
                className="mt-2"
                disabled={isDisabled || model?.bloquearDownload}
                model={{
                  label: intl.formatMessage({
                    id: 'bloquearDownloadAposVencimentoDocumento',
                  }),
                  value: model?.bloquearDownloadAposVencimentoDocumento,
                  requestChange: (value) =>
                    onChangeValue(
                      'bloquearDownloadAposVencimentoDocumento',
                      value
                    ),
                }}
              />
            </Col>
            <Col md={12}>
              <CheckBox
                className="mt-2"
                disabled={isDisabled || model?.bloquearDownload}
                model={{
                  label: intl.formatMessage({
                    id: 'bloquearDownloadAposConclusaoDocumento',
                  }),
                  value: model?.bloquearDownloadAposConclusaoDocumento,
                  requestChange: (value) =>
                    onChangeValue(
                      'bloquearDownloadAposConclusaoDocumento',
                      value
                    ),
                }}
              />
            </Col>
          </Row>
        </PanelCollapse>
      )}
      {ehCopiaControlada && (
        <PanelCollapse
          open={false}
          header={intl.formatMessage({
            id: 'labelCopiasControladasDistribuidas',
          })}
        >
          <DistribuicaoCopiasControladas
            documentoId={model?.id}
            refreshTrigger={refreshTrigger}
            enabled={ehCopiaControlada}
          />
        </PanelCollapse>
      )}
    </div>
  );
}

export default ConfiguracoesTab;
